import React, { useState, useContext } from 'react';
import axios from 'axios';
import './ReportTrigger.css';
import { AuthContext } from '../context/AuthContext';

const ReportTrigger = () => {
  const { user, loading: authLoading } = useContext(AuthContext);
  const [status, setStatus] = useState('');
  const [loading, setLoading] = useState(false);

  const trigger = async (type) => {
    setStatus('');
    setLoading(true);

    try {
      const res = await axios.post(`/admin/run-${type}`, {}, {
        headers: {
          'x-admin-secret': process.env.REACT_APP_ADMIN_SECRET,
        },
      });
      setStatus(res.data.message);
    } catch (err) {
      setStatus(`❌ Error: ${err.response?.data?.message || err.message}`);
    } finally {
      setLoading(false);
    }
  };

  // If auth is loading
  if (authLoading) return <p>Loading...</p>;

  // Restrict access to only admin users
  if (!user || user.role !== 'admin') {
    return <p>🚫 Access Denied. Only admins can trigger reports.</p>;
  }

  return (
    <div className="trigger-page">
      <h2>🛠 Trigger Cron Reports</h2>
      <div className="button-group">
        <button onClick={() => trigger('daily')} disabled={loading}>Run Daily Report</button>
        <button onClick={() => trigger('monthly')} disabled={loading}>Run Monthly Report</button>
        <button onClick={() => trigger('yearly')} disabled={loading}>Run Yearly Report</button>
      </div>
      {loading && <p>⏳ Running...</p>}
      {status && <p className="status-msg">{status}</p>}
    </div>
  );
};

export default ReportTrigger;
